<template>
  <div>
    <!-- hero section -->
    <section class="section section-container-hero section-shaped hero my-0">
      <div class="shape"></div>
      <div class="container shape-container d-flex align-items-center">
        <div class="col px-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-7 text-center col-md-5">
              <h2 class="display-2 text-white mb-5 hero-title">
                PROJECT SITES
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Project Sites desc -->
    <section>
      <div class="col px-0">
        <div class="justify-content-center align-items-center">
          <div class="container mt-4 col-lg-10 col-md-7">
            <p class="text-gray m-2 paraTEXT text-justify">
              EasyHomes is known for being the market leader for precast
              perimeter fencing. Our team does extensive research before
              launching any product. Through this, we have become one of the
              most trusted manufacturers and installers of concrete precast
              fence products in the country. We received recognition from the
              Intellectual Property Office of the Philippines as the company
              with the HIGHEST NUMBER OF FILED PATENTS for the period 1998-2017.
            </p>
            <p class="text-gray m-2 paraTEXT text-justify">
              Easyhomes Inc. is a precast fence building company offering a
              complete range products. At Easyhomes, we never sacrifice quality – we have
              a philosophy of getting the job done right, on time, and within
              budget. You can also be sure that from establishment of a
              partnership to its installation, we are with you all the way.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section mt-0 p-0">
      <div class="px-0 mb-4 mt-4" v-for="(project, index) in filteredProjects" :key="index">
        <div class="odd" v-if="index % 2 !== 0">
          <ComponentRight :project="project" :key="index" />
        </div>

        <div class="even" v-else>
          <ComponentLeft :project="project" :key="index" />
        </div>
      </div>
    </section>

    <div class="mb-lg">
      <!-- Space -->
    </div>
  </div>
</template>

<script>
import ComponentLeft from './components/projects/ComponentLeft'
import ComponentRight from './components/projects/ComponentRight'
import projectDAO from '../database/projects'

export default {
  name: 'project-sites',
  components: {
    ComponentLeft,
    ComponentRight,
  },
  data() {
    return {
      projects: []
    }
  },

  computed: {
    filteredProjects() {
      return this.projects.filter((project) => project.isActive !== false)
    },
  },

  created() {
    this.retrieveAll()
  },
  methods: {
    async retrieveAll() {
      try {
        const data = await projectDAO.retrieveAll()
        this.projects = data
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.hero {
  background-image: url('/img/commons/optimized/project-sites.png');
  background-attachment: fixed;
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
}

.hero-title {
  width: 100%;
  font-size: 3rem;
  margin-top: 50px;
  margin-left: -350px;
  text-shadow: 1px 1px black;
}

.paraTEXT {
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 40px;
}

.container {
  max-width: 95.33333%;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
    font-size: 2.5rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
    font-size: 4rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .hero-title {
    margin-left: -40% !important;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: -50% !important;
  }
}
</style>
